import route from '../../constants/routes';
import { getRoutePartWithSlug } from '../../utils/common';

export const getFestivalRoute = festival =>
  `${route.FESTIVALS}/${festival?.country?.slug}/${getRoutePartWithSlug(festival)}`;
